@if (gameInfo$ | async; as gameDetails) {
  <ion-content>
    @if (gameDetails) {
      <ion-grid>
        <ion-row>
          <ion-col size="12" class="upper-col">
            <div class="upper-col__content">
              <div class="upper-coverimage-overlay"></div>
              <ion-buttons slot="start" (click)="goBack()">
                <img src="assets/images/page-back-icon-white.png" class="back-ic" />
              </ion-buttons>
              <img alt="game-image" class="game-cover-image" src="{{ gameDetails?.game_popup_image_url }}" />
            </div>
          </ion-col>
          <ion-col size="12" class="bottom-col">
            <div class="bottom-col__content">
              <h2 class="top-price">
                @if (gameDetails?.game_id && !gamesWithNoPrize?.includes(gameDetails?.game_id)) {
                  <span>
                    {{
                    ("game_details_page.top_prize" | translate) ? ("game_details_page.top_prize" | translate) : "Top Prize"
                    }}
                    : {{ gameTopPrize }}
                  </span>
                }
              </h2>
              <h6 class="bottom-col__content__header">
                @if (gameDetails?.game_price > 0) {
                  <span>{{flashSaleEnabled ? salesCost : gameDetails?.game_price}}
                    {{
                    ("game_details_page.points_per_play" | translate)
                    ? ("game_details_page.points_per_play" | translate)
                    : "points per play"
                  }}</span>
                }
                @if (gameDetails?.game_price === 0) {
                  <span>
                    {{
                    ("game_details_page.free_play" | translate)
                    ? ("game_details_page.free_play" | translate)
                    : "Free play"
                  }}</span>
                }
              </h6>
              <h6 class="bottom-col__content__subheader">
                <!-- {{ gameDetails?.country_code_data[gameDetails?.cc]?.game_popup_details }} -->
                {{ popupDetails }}
              </h6>
              @if (learnMoreRules) {
                <h6 class="bottom-col__content__subheaderRules">
                  {{ learnMoreRules }}
                </h6>
              }
              <!-- Condition to check for gameId != 525 is to hide Prize list for Enchanted Slots game -->
              <!-- For other UI changes, we can add specific game ID in games-repo service's 'gamesWithNoPrize' array -->
              @if (priceList && priceList.length > 0  && gameDetails?.game_id && !gamesWithNoPrize?.includes(gameDetails?.game_id) && gameDetails?.game_id !== 525) {
                <div
                  class="bottom-col__content__prize-list">
                  <h4 class="bottom-col__content__prize-list__header">
                    {{
                    ("game_details_page.prize_list" | translate)
                    ? ("game_details_page.prize_list" | translate)
                    : "Prize list"
                    }}
                  </h4>
                  <!-- <div class="bottom-col__content__prize-list__list"
                  *ngFor="let prize of priceList; let i = index"
                  [class.winner]="prize?.winner === true">
                  <ion-row class="bottom-col__content__prize-list__list__row">
                    <ion-col size="10" class="bottom-col__content__prize-list__list__row__detail">
                      <h6>{{ i + 1 }}</h6>
                      <h4 [ngClass]="{ 'price-win': i === 0 }">
                        {{prize}}
                      </h4>
                    </ion-col>
                    <ion-col size="2" class="bottom-col__content__prize-list__list__row__winner">
                      <img *ngIf="i === 0" alt="game-winner" src="../../assets/images/win-icon.svg" />
                    </ion-col>
                  </ion-row>
                </div> -->
                <ion-row class="bottom-col__content__prize-list__list__row">
                  <ion-col size="10" class="bottom-col__content__prize-list__list__row__detail">
                    <h6>1</h6>
                    <h4 class="price-win top-row">
                      {{ priceList[0] }}
                    </h4>
                  </ion-col>
                  <ion-col size="2" class="bottom-col__content__prize-list__list__row__winner">
                    <img alt="game-winner" src="../../assets/images/win-icon.svg" />
                  </ion-col>
                </ion-row>
                @for (prize of priceList; track prize; let i = $index) {
                  <div
                    class="bottom-col__content__prize-list__list"
                    [class.winner]="prize?.winner === true"
                    >
                    @if (i % 2 == 1) {
                      <ion-row class="bottom-col__content__prize-list__list__row">
                        @if (i < priceList.length) {
                          <ion-col
                            size="6.5"
                            class="bottom-col__content__prize-list__list__row__detail"
                            >
                            <h6 [ngClass]="i > 8 ? 'prize-digit-margin' : ''">{{ i + 1 }}</h6>
                            <h4>
                              {{ priceList[i] }}
                            </h4>
                          </ion-col>
                        }
                        @if (i + 1 < priceList.length) {
                          <ion-col
                            size="5.5"
                            class="bottom-col__content__prize-list__list__row__detail"
                            >
                            <h6 [ngClass]="i > 8 ? 'prize-digit-margin' : ''">{{ i + 2 }}</h6>
                            <h4>
                              {{ priceList[i + 1] }}
                            </h4>
                          </ion-col>
                        }
                      </ion-row>
                    }
                  </div>
                }
              </div>
            }

            @if (gameDetails?.prize_details && (gameDetails?.prize_details | keyvalue).length > 0) {
            <div class="bottom-col__content__prize-list">
              <h4 class="bottom-col__content__prize-list__header">
                {{
                ("game_details_page.prize_list" | translate)
                ? ("game_details_page.prize_list" | translate)
                : "Prize list"
                }}
              </h4>
              @for (lootBox of gameDetails?.prize_details | keyvalue: compareFn; track lootBox) {
              <div class="bottom-col__content__prize-list__list">
                @if (gameDetails?.game_id != hidePrizeHeading && (gameDetails.prize_details | keyvalue).length > 1) {
                <h6 class="price-win bottom-col__content__prize-list__header">{{lootBox.key}}</h6>
                }
                <ion-row class="bottom-col__content__prize-list__list__row">
                  <ion-col size="10" class="bottom-col__content__prize-list__list__row__detail">
                    <h6>1</h6>
                    <h4 class="price-win bottom-col__content__prize-list__header fw-500">
                      {{ lootBox.value[0]?.type === "game" ? lootBox.value[0]?.award_name :
                      lootBox.value[0]?.int_award_name[languageCode] }}
                    </h4>
                  </ion-col>
                  <ion-col size="2" class="bottom-col__content__prize-list__list__row__winner">
                    <img alt="game-winner" src="../../assets/images/win-icon.svg" />
                  </ion-col>
                </ion-row>
                @if(lootBox?.value?.length) {
                @for (item of lootBox?.value; track item; let i = $index) {
                <div class="bottom-col__content__prize-list__list">
                  @if (i % 2 == 1) {
                  <ion-row class="bottom-col__content__prize-list__list__row">
                    @if (i < lootBox.value.length) { <ion-col size="6.5" class="bottom-col__content__prize-list__list__row__detail">
                      <h6 [ngClass]="i > 8 ? 'prize-digit-margin' : ''">{{ i + 1 }}</h6>
                      <h4>
                        {{ lootBox.value[i]?.type === "game" ? lootBox.value[i]?.award_name :
                        lootBox.value[i]?.int_award_name[languageCode] }}
                      </h4>
                      </ion-col>
                      }
                      @if (i + 1 < lootBox.value.length) { <ion-col size="5.5"
                        class="bottom-col__content__prize-list__list__row__detail">
                        <h6 [ngClass]="i > 8 ? 'prize-digit-margin' : ''">{{ i + 2 }}</h6>
                        <h4>
                          {{ lootBox.value[i+1]?.type === "game" ? lootBox.value[i+1]?.award_name :
                          lootBox.value[i+1]?.int_award_name[languageCode] }}
                        </h4>
                        </ion-col>
                        }
                  </ion-row>
                  }
                </div>
                }
                }
              </div>
              }
            </div>
            }
            
            @if (gameDetails?.screen_shot && gameDetails?.screen_shot?.length) {
              <div
                class="bottom-col__content__screenshots"
                >
                <h4>
                  {{
                  ("game_details_page.screenshots" | translate)
                  ? ("game_details_page.screenshots" | translate)
                  : "Screenshots"
                  }}
                </h4>
                <ion-row class="bottom-col__content__screenshots__row">
                  @for (screenshot of gameDetails?.screen_shot; track screenshot) {
                    <ion-col>
                      @if (screenshot) {
                        <img alt="image-url" src="{{ screenshot }}" ionImgViewer />
                      }
                      @if (!screenshot || screenshot == 'unknown') {
                        <img
                          alt="image-url"
                          src="assets/images/broken_image.png"
                          ionImgViewer
                          />
                      }
                    </ion-col>
                  }
                </ion-row>
              </div>
            }
            <div class="button-wrapper">
              <ion-button expand="block" shape="round" class="play-now" [disabled]="isButtonDisabled" (click)="playGame(gameDetails); startSpinner()">
                @if (!spinnerAnimation && proceed) {
                  <span>{{
                    ("game_details_page.play_now" | translate) ? ("game_details_page.play_now" | translate) : "Play now"
                  }}</span>
                }
                @if (spinnerAnimation && proceed) {
                  <div class="spinners">
                    <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="30">
                    </mat-progress-spinner>
                  </div>
                }
                @if (!proceed && !spinnerAnimation) {
                  <mat-icon [@bounceIn] class="tick-mark">{{
                    ("game_details_page.done_btn" | translate) ? ("game_details_page.done_btn" | translate) : "done"
                  }}</mat-icon>
                }
              </ion-button>
            </div>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  }
</ion-content>
} @else {
  <app-in-progress-animation></app-in-progress-animation>
}
